// Details remains usable without JavaScript. Close desktop dropdowns on Escape/outside click.
(() => {
  if (window.partalarmNavigationReady) return;
  window.partalarmNavigationReady = true;
  let scheduled = false;
  let localizationWidth = 0;
  const syncManualPages = (header) => {
    // Restore titles before applying current editor data; repeated calls stay idempotent.
    header.querySelectorAll('[data-pa-original-label]').forEach(link => {
      link.textContent = link.dataset.paOriginalLabel;
    });
    header.querySelectorAll('[data-pa-added-link]').forEach(item => item.remove());
    const templates = header.querySelectorAll('.pa-nav-config template[data-pa-manual-link]');
    header.querySelectorAll('.pa-nav__item[data-pa-menu-key]').forEach(item => {
      const list = item.querySelector('.pa-nav__children');
      const heading = item.querySelector('.pa-nav__direct');
      const details = item.querySelector('.pa-nav__group');
      if (!list || !heading || !details) return;
      templates.forEach(template => {
        if (template.dataset.paKey !== item.dataset.paMenuKey) return;
        const content = template.content.cloneNode(true);
        const entry = content.querySelector('li');
        const incoming = entry?.querySelector('a');
        if (!entry || !incoming) return;
        const existing = Array.from(list.querySelectorAll('a')).find(a => a.href === incoming.href);
        if (existing) {
          if (!existing.hasAttribute('data-pa-original-label')) existing.dataset.paOriginalLabel = existing.textContent;
          existing.textContent = incoming.textContent;
        } else {
          entry.dataset.paAddedLink = 'true';
          list.append(entry);
        }
      });
      const hasChildren = !!list.querySelector('a');
      details.hidden = !hasChildren;
      heading.classList.toggle('pa-nav__heading', hasChildren);
      item.hidden = item.dataset.paHasTarget !== 'true' && !hasChildren;
      if (item.dataset.paHasTarget !== 'true' && hasChildren) heading.href = list.querySelector('a').href;
    });
  };
  const update = () => {
    const header = document.querySelector('#header-component');
    const nav = header?.querySelector('.pa-nav__desktop');
    if (!header || !nav) return;
    syncManualPages(header);
    const copy = nav.cloneNode(true);
    copy.querySelectorAll('details').forEach(d => d.open = false);
    copy.setAttribute('aria-hidden', 'true');
    copy.setAttribute('inert', '');
    copy.classList.add('pa-nav', 'pa-nav-measure');
    copy.style.font = getComputedStyle(nav).font;
    document.body.append(copy);
    const navWidth = copy.getBoundingClientRect().width;
    copy.remove();
    const logo = header.querySelector('header-logo, .header-logo');
    const actions = header.querySelector('header-actions');
    const localization = header.querySelector('.dropdown-localization');
    localizationWidth = Math.max(localizationWidth, localization?.getBoundingClientRect().width || 0);
    const row = header.querySelector('.header__row--top');
    const rowStyles = row ? getComputedStyle(row) : null;
    const margins = rowStyles ? (parseFloat(rowStyles.paddingLeft) || 0) + (parseFloat(rowStyles.paddingRight) || 0) : 64;
    const required = navWidth + (logo?.getBoundingClientRect().width || 200) +
      (actions?.getBoundingClientRect().width || 100) + localizationWidth + margins + 144;
    const mode = window.innerWidth < Math.max(1100, required) ? 'drawer' : 'menu';
    if (header.dataset.menuStyle !== mode) {
      header.dataset.menuStyle = mode;
      if (mode === 'menu') header.querySelector('header-drawer')?.close?.();
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  window.partalarmUpdateNavigation = schedule;
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', event => {
    schedule();
    const config = event.target.closest?.('[data-pa-config-kind]') || event.target.querySelector?.('[data-pa-config-kind]');
    const key = config?.dataset.paKey;
    if (!key) return;
    requestAnimationFrame(() => {
      const header = document.querySelector('#header-component');
      if (!header) return;
      if (header.dataset.menuStyle === 'drawer') {
        const drawer = header.querySelector('header-drawer');
        const outer = drawer?.querySelector('details');
        if (outer && !outer.open) { outer.open = true; drawer.open?.(); }
      }
      header.querySelectorAll('.pa-nav__item[data-pa-menu-key]').forEach(item => {
        if (item.dataset.paMenuKey === key) {
          const details = item.querySelector('.pa-nav__group');
          if (details && !details.hidden) details.open = true;
        }
      });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.fonts?.ready.then(schedule);
  const desktopGroups = () => document.querySelectorAll('.header-menu.pa-nav .pa-nav__group[open]');
  document.addEventListener('click', event => {
    desktopGroups().forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    desktopGroups().forEach(group => {
      if (group.contains(document.activeElement)) group.querySelector('summary')?.focus();
      group.open = false;
    });
  });
  document.addEventListener('toggle', event => {
    const group = event.target;
    if (!(group instanceof HTMLDetailsElement) || !group.open || !group.closest('.header-menu.pa-nav')) return;
    desktopGroups().forEach(other => { if (other !== group) other.open = false; });
  }, true);
})();
